import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import throttle from 'lodash/throttle';
import styled from 'styled-components';

// Styled Components
import { SmartContainer, Stack, } from '../../../styles/Containers';
import { StyledChip } from '../../../styles/matieralui/Chip';

// Components
import { StyledP } from '../../../styles/StyledHTML';

// Icons
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { Menu, Tooltip, } from '@mui/material';
import { DateRangeOutlined } from '@mui/icons-material';
import { DateRange } from '../../../components/QueryBuilder/DateRange';
import { FullUI } from '../../../redux/UI/ui.selectors';
import { uiStorage } from '../../../redux/UI/ui.actions';
import { IconClearDateRange, IconDateRange, IconDateRangeFilled } from '../../Icons';

export const FilterDateRange = ({ storageKey, onChange, value }) => {

  const dispatch = useDispatch();
  const ui = FullUI();
  const [anchor, setAnchor] = useState(null);


  const openMenu = (event) => setAnchor(event.currentTarget);

  const closeMenu = () => setAnchor(null);

  const handleChange = (v) => {
    dispatch(uiStorage({ [storageKey]: v }))
    onChange(v);
  }



  return (

    <SmartContainer>
      <Tooltip title="Filter By Date" placement="top">
        <StyledIconButton onClick={openMenu}>
          {(value?.start || value?.end) && (<IconClearDateRange />)}
          {(!value?.start && !value?.end) && (<IconDateRange />)}
        </StyledIconButton>
      </Tooltip>
      <Menu
        open={Boolean(anchor)}
        onClose={closeMenu}
        anchorEl={anchor}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <SmartContainer style={{ margin: "10px" }}>
          <Stack>
            <StyledP>Filter By Date Range</StyledP>
            <DateRange
              value={value}
              onChange={(v) => handleChange(v)}
              clear={() => handleChange(null)}
            />
          </Stack>
        </SmartContainer>
      </Menu>
    </SmartContainer>

  )
}